import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4dc93824"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toolbar navigation-bar" }
const _hoisted_2 = {
  class: "wbtn-array",
  style: {"grid-column":"2"}
}
const _hoisted_3 = {
  class: "wbtn-array right-aligned",
  style: {"grid-column":"3"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "main-group", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "right-group", {}, undefined, true)
    ])
  ]))
}